import React from 'react';
import SalesIndex from '../whole';
import {usePhaseState} from 'funnel-schedule/phase-context';

export default function () {
  const {
    phases: {challenge: challengeSchedule = {phase: 'before'}}
  } = usePhaseState();
  const challengePhase = challengeSchedule.phase;
  return (
    <SalesIndex
      version={challengePhase === 'after' ? 'salesFull' : 'challenge'}
      trialLength="14"
      shareImage="https://s3.us-west-2.amazonaws.com/cdn.foodrevolution.org/wlc/challenge/og/wlc-lc-202504-open-graph-sales.png"
    />
  );
}
